// extracted by mini-css-extract-plugin
export default {"article":"_0aYKV0G1--AppDownloadArticle_article__IoG4G","wiggle":"_0aYKV0G1--AppDownloadArticle_wiggle__+Eaqi","shimmer":"_0aYKV0G1--AppDownloadArticle_shimmer__zhrf6"};